import React from "react";
import {connect} from "react-redux";
import {commons, FixedDropDownButton, Icon, modal, utils} from "@mc/mc-legacy";
import GroupMenu from "../components/GroupMenu";
import CustomPageLayout from "./CustomPageLayout";
import * as actions from "../actions/pozadavkyVyrizeneActions";
import * as pdfViewerActions from "../actions/pdfViewerActions";
import {Col, DropdownItem, Row} from "reactstrap";
import {getStatusIcon} from "../components/StatusBar";
import SignRequestInfoData from "../components/SignRequestInfoData";
import SignRequestTitle from "../components/SignRequestTitle";
import ShowButton from "../components/ShowButton";
import * as groupMenuActions from "../actions/groupMenuActions";
import * as pozadavkyActions from "../actions/pozadavkyActions";
import EnumState from "../api/gen/qsign/types/EnumState";
import Type from "../api/gen/qsign/types/Type";
import MessageEmptyList from "../components/MessageEmptyList";
import signRequestInternalApi from "../api/gen/qsign/SignRequestInternalApi";
import PodepisovaniPdfViewer from "../components/PodepisovaniPdfViewer";
import ActionCountIcon from "../components/ActionCountIcon";
import "./CustomItem.scss";
import ItemListFixed from "../components/ItemListFixed";
import PrilohyButton from "../components/PrilohyButton";
import SignRequestWithCountsVO from "../api/gen/qsign/types/SignRequestWithCountsVO";

const {sinkEvent} = commons;

/**
 * Vyřízené požadavky page.
 */

class PozadavkyVyrizenePage extends React.Component {
    componentDidMount() {
        this.fetchData(this.props, true);
        this.handleFilter();
    }

    handleFilter() {
        const {filterList} = this.props;
        this.props.dispatch(pozadavkyActions.filter({...filterList.filter, stateList: [EnumState.SIGNED]}));
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.fetchData(nextProps, false);
    }

    fetchData = (props, forceFetch) => {
        const {dispatch} = props;
        dispatch(actions.fetchIfNeeded(forceFetch));

        if (forceFetch) {
            dispatch(groupMenuActions.invalidate());
        }
    };
    checkClickActive = (count, callback, ...params) => {
        return count > 0 ? () => callback(...params) : null;
    };
    handleZobrazit = (signRequest, type, viewMode) => {
        this.props.dispatch(
            pdfViewerActions.showDocuments(
                signRequest,
                false,
                type,
                () => {
                    this.fetchData(this.props, true);
                },
                viewMode
            )
        );
    };
    handleDeleteRequest = (signRequest) => {
        const {dispatch} = this.props;
        dispatch(
            modal.ModalActions.showConfirm(
                "Potvrzení smazání",
                "Opravdu chcete smazat požadavek?",
                () =>
                    signRequestInternalApi.deleteSignRequest(signRequest.id).then(() => {
                        this.fetchData(this.props, true);
                    }),
                null,
                "Smazat"
            )
        );
    };
    renderItem = (item: SignRequestWithCountsVO, icon) => {
        const {error} = item;

        // dokumenty požadavku byly schvalovány
        const approved = item.approvedDocuments > 0;

        const statusItems = [
            {
                status: "signed",
                count: approved ? item.approvedDocuments : item.signedDocuments,
                title: approved ? "Schválených dokumentů: " + item.approvedDocuments : "Podepsaných dokumentů: " + item.signedDocuments,
                onClick: this.checkClickActive(
                    approved ? item.approvedDocuments : item.signedDocuments,
                    this.handleZobrazit,
                    item,
                    approved ? Type.APPROVED : Type.SIGNED,
                    PodepisovaniPdfViewer.VIEW_MODE.BASE
                ),
            },
        ];
        return (
            <div className="custom-item">
                <div className="custom-item-content">
                    <Row noGutters className="ml-3">
                        <Col xs={12}>
                            <SignRequestTitle
                                onClick={() => this.handleZobrazit(item, null, PodepisovaniPdfViewer.VIEW_MODE.BASE)}
                                signRequest={item}
                                customRender={(item) => {
                                    if (item.attachmentCount > 0) {
                                        return <PrilohyButton attachmentCount={item.attachmentCount} itemID={item.id}/>;
                                    }
                                }}
                            />
                        </Col>
                        <Col>
                            <SignRequestInfoData signRequest={item}/>
                        </Col>
                    </Row>
                </div>
                <div className="custom-item-action">
                    {!error &&
                        statusItems.map((value, key) => {
                            const icon = getStatusIcon(value.status);
                            return (
                                <ActionCountIcon
                                    key={key}
                                    onClick={value.onClick}
                                    title={value.title}
                                    icon={icon.icon}
                                    color={icon.color}
                                    count={value.count}
                                />
                            );
                        })}
                    {this.renderActions(item)}
                </div>
            </div>
        );
    };
    renderActions = (item) => {
        const type = item.approvedDocuments > 0 ? Type.APPROVED : Type.SIGNED;
        return (
            <div className="actions actions-button">
                <ShowButton onClick={() => this.handleZobrazit(item, null, PodepisovaniPdfViewer.VIEW_MODE.BASE)}/>
                {this.renderDropDown(item, item.source === "MANUALLY")}
            </div>
        );
    };
    renderDropDown = (item, isManual) => {
        return (
            <FixedDropDownButton disabled={!isManual}
                                 onClick={sinkEvent}
                                 color="action"
                                 noCaret
                                 title={<Icon icon="ellipsis-v" className="action-ellipsis"/>}
            >
                <DropdownItem key="0" href={moduleContextPath + `/api/signRequest/${item.id}/download/zip`}>
                    Uložit podepsané dokumenty
                </DropdownItem>
                <DropdownItem key="1" onClick={() => this.handleDeleteRequest(item)}>
                    Smazat požadavek
                </DropdownItem>
            </FixedDropDownButton>
        );
    };

    render() {
        const {itemList} = this.props;
        const listProps = {
            itemList,
            loadMore: actions.loadMore,
            invalidatePozadavky: actions.invalidatePozadavky,
            renderItem: this.renderItem,
            emptyList: (
                <MessageEmptyList>
                    <div className="message">Žádné vyřízené požadavky</div>
                </MessageEmptyList>
            ),
        };
        return (
            <CustomPageLayout header title="Vyřízené požadavky" menu={<GroupMenu/>}>
                <ItemListFixed {...listProps} />
            </CustomPageLayout>
        );
    }
}

function mapStateToProps(state) {
    return {
        itemList: utils.storeFromArea(state, actions.POZADAVEK_VYRIZENE_LIST),
        filterList: utils.storeFromArea(state, pozadavkyActions.POZADAVKY_SEARCH_LIST),
    };
}

export default connect(mapStateToProps)(PozadavkyVyrizenePage);
